var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styles from './AssessmentGateFunctionSummariesTable.module.scss';
import columnSharedStyles from '@app/Components/Grid/SharedStyles/column-shared-styles.module.scss';
import { RatingPicker } from '@app/Components/RatingPicker/RatingPicker';
import { observer } from 'mobx-react';
import { Grid } from '@app/Components/Grid/Grid';
import { Column } from 'devextreme-react/data-grid';
import { ProjectState, ChecklistSections, ObjectType, SignalREvents, GateProcessTypeEnum, Events } from '@app/AppConstants';
import { observable, action } from 'mobx';
import { Api } from '@app/Api';
import { FunctionFilterContext } from '@app/Components/FunctonFilter/FunctionFilterContext';
import { filterFunctionSummariesTableRowsByFunction } from '@app/Components/FunctonFilter/FunctionFilter';
import { CommentsSummary } from '@app/Components/Grid/CommentsSummary/CommentsSummary';
import { CommentsList } from '@app/Components/Grid/CommentsList/CommentsList';
import { EditCell } from '@app/Components/Grid/EditCell/EditCell';
import { RatingCell } from '@app/Components/Grid/RatingCell/RatingCell';
import { createUniqueId } from '@app/Helpers/UidHelper/UidHelper';
import { FunctionSummaryStatus } from '@app/Components/Grid/FunctionSummaryStatus/FunctionSummaryStatus';
import HTMLReactParser from 'html-react-parser';
import { signalRService } from '@app/Services/SignalRService';
import { ChangeLogDialog } from '@app/Components/Dialogs/ChangeLogDialog';
import { AddActionItemWrapper } from '@app/Components/AddActionItemWrapper/AddActionItemWrapper';
import { ConfirmButton } from '@app/Components/ConfirmButton/ConfirmButton';
import { CodeCell } from '@app/Components/Grid/CodeCell/CodeCell';
import { FunctionList } from '@app/Components/Grid/FunctionList/FunctionList';
import { RatingFilterAssessmentContext } from '@app/Components/RatingFilterAssessment/RatingFilterAssessmentContext';
import { filterItemsTableRowsByRoleAndRating } from '@app/Components/RatingFilterAssessment/RatingFilterAssessment';
export var AssessmentGateFunctionSummariesTable = /** @class */ (function (_super) {
    __extends(AssessmentGateFunctionSummariesTable, _super);
    function AssessmentGateFunctionSummariesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._functionSummaries = [];
        _this._currentCheckListItem = null;
        _this._loading = false;
        _this._gridRef = React.createRef();
        return _this;
    }
    AssessmentGateFunctionSummariesTable.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        signalRService.subscribe(SignalREvents.recommendationChanged, this._loadSummaries);
                        document.addEventListener(Events.assessmentGateFunctionSummariesConfirm, this._loadSummaries);
                        return [4 /*yield*/, this._loadSummaries()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AssessmentGateFunctionSummariesTable.prototype.componentWillUnmount = function () {
        signalRService.unsubscribe(SignalREvents.recommendationChanged, this._loadSummaries);
        document.removeEventListener(Events.assessmentGateFunctionSummariesConfirm, this._loadSummaries);
    };
    AssessmentGateFunctionSummariesTable.prototype._savePMSummary = function (rowData) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 6]);
                        return [4 /*yield*/, Api.secured.updateProjectManagerFunctionSummary({ body: rowData })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.onRefreshChecklistStatusOverview()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        error_1 = _a.sent();
                        if (!error_1) return [3 /*break*/, 5];
                        console.error(error_1);
                        return [4 /*yield*/, this._loadSummaries()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AssessmentGateFunctionSummariesTable.prototype.reloadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadSummaries()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AssessmentGateFunctionSummariesTable.prototype._saveAssessorSummary = function (rowData) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 6]);
                        return [4 /*yield*/, Api.secured.updateAssessorFunctionSummary({ body: rowData })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.onRefreshChecklistStatusOverview()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        error_2 = _a.sent();
                        if (!error_2) return [3 /*break*/, 5];
                        console.error(error_2);
                        return [4 /*yield*/, this._loadSummaries()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AssessmentGateFunctionSummariesTable.prototype._saveOkAssessorPart = function (checkListItemId, rowData, rowIndex) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var projectState, row;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        projectState = this.props.projectState;
                        return [4 /*yield*/, Api.secured.okFunctionSummaryAssessorPart({ checkListItemId: checkListItemId, projectState: projectState })];
                    case 1:
                        row = _b.sent();
                        (_a = Object.keys(rowData)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                            rowData[key] = row[key];
                        });
                        if (this._gridRef.current) {
                            this._gridRef.current.repaintRows([rowIndex]);
                        }
                        return [4 /*yield*/, this.props.onRefreshChecklistStatusOverview()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AssessmentGateFunctionSummariesTable.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(prevProps.gateId !== this.props.gateId || prevProps.hideNAItems !== this.props.hideNAItems)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._loadSummaries()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AssessmentGateFunctionSummariesTable.prototype._loadSummaries = function () {
        return __awaiter(this, void 0, void 0, function () {
            var projectId, gateId, projectState, hideNAItems, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        projectId = (_b = this.props, _b.projectId), gateId = _b.gateId, projectState = _b.projectState, hideNAItems = _b.hideNAItems;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 3, 4]);
                        this._loading = true;
                        _a = this;
                        return [4 /*yield*/, Api.secured.getGateAssessmentFunctionSummaries({
                                projectId: projectId,
                                gateId: gateId,
                                projectState: projectState,
                                hideNAItems: hideNAItems
                            })];
                    case 2:
                        _a._functionSummaries = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this._loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AssessmentGateFunctionSummariesTable.prototype._toggleLogModal = function () {
        this._currentCheckListItem = null;
    };
    AssessmentGateFunctionSummariesTable.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var projectState = (_a = this.props, _a.projectState), projectId = _a.projectId, gateId = _a.gateId, onRefreshActionItems = _a.onRefreshActionItems, openModalLink = _a.openModalLink, isProjectTerminatedOrCompleted = _a.isProjectTerminatedOrCompleted;
        var _functionSummaries = (_b = this, _b._functionSummaries), _loading = _b._loading;
        return (React.createElement(React.Fragment, null,
            React.createElement(RatingFilterAssessmentContext.Consumer, null, function (ratingFilterValue) {
                return (React.createElement(FunctionFilterContext.Consumer, null, function (functionFilterValue) {
                    var rows = filterItemsTableRowsByRoleAndRating(_functionSummaries, ratingFilterValue);
                    rows = filterFunctionSummariesTableRowsByFunction(rows, functionFilterValue);
                    var count = rows.length;
                    return (React.createElement(Grid, { ref: _this._gridRef, dataSource: __spreadArray([], rows, true), expandableRows: true, rowsCount: count, loading: _loading },
                        React.createElement(Column, { caption: "ID", dataField: "code", width: 100, cssClass: columnSharedStyles.colWithHistory, cellRender: function (_a) {
                                var data = _a.data;
                                return (React.createElement(CodeCell, { code: data.code, onHistoryClick: function () { return (_this._currentCheckListItem = data); } }));
                            } }),
                        React.createElement(Column, { caption: "Function Name", width: 170, cellRender: function (_a) {
                                var data = _a.data;
                                return (React.createElement(FunctionList, { functions: data.functions, rowId: '' + data.id }));
                            } }),
                        React.createElement(Column, { caption: "Question", dataField: "question", width: 350, cellRender: function (_a) {
                                var data = _a.data;
                                return (React.createElement("div", null,
                                    data.questionTitle && (React.createElement("div", { className: styles.questionTitle }, data.questionTitle)),
                                    React.createElement("div", { style: { whiteSpace: 'pre-line' } }, HTMLReactParser(data.question || ''))));
                            } }),
                        React.createElement(Column, { caption: "Guideline", dataField: "guideline", minWidth: 300, cellRender: function (_a) {
                                var data = _a.data;
                                return (React.createElement("div", { style: { whiteSpace: 'pre-line' } }, HTMLReactParser(data.guideline || '')));
                            } }),
                        projectState !== ProjectState.HasOnlyMasterCheckLists && (React.createElement(Column, { caption: "Function Answers", width: 200, cellRender: function (_a) {
                                var data = _a.data;
                                return (React.createElement("div", null,
                                    data.isMasterFunctionSummary ? null : (React.createElement(CommentsSummary, { id: 'f' + data.id, green: data.greenRatingCount, yellow: data.yellowRatingCount, red: data.redRatingCount, notApplicable: data.notApplicableRatingCount, notRated: data.notRatingCount, notRatedCodes: data.notRatingCheckListItems, notCommented: data.notCommentedCount, notCommentedCodes: data.notCommentedCheckListItems, link: openModalLink, isVisible: true })),
                                    React.createElement(CommentsList, { comments: data.functionalComments })));
                            } })),
                        projectState !== ProjectState.HasOnlyMasterCheckLists && (React.createElement(Column, { headerCellRender: function () { return React.createElement("div", { title: "Function Rating" }, "Rating"); }, width: 60, cellRender: function (_a) {
                                var data = _a.data;
                                return (React.createElement(RatingPicker, { rating: data.functionalRating, disabled: true }));
                            } })),
                        React.createElement(Column, { caption: "Project Manager Answer", width: 300, cssClass: styles.projectManagerCommentCell, cellRender: function (_a) {
                                var data = _a.data, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
                                return (React.createElement(EditCell, { rowIndex: rowIndex, columnIndex: columnIndex, value: data.projectManagerOriginalComment, onChange: function (value) {
                                        data.projectManagerOriginalComment = value;
                                        if (_this._gridRef.current) {
                                            _this._gridRef.current.repaintRows([rowIndex]);
                                        }
                                    }, onSave: function () { return _this._savePMSummary(data); }, objectUniqueId: createUniqueId(ObjectType.ChecklistItem, data.id), withCopy: true, section: ChecklistSections.ProjectManager, disabled: !data.canPrincipalUpdateProjectManagerPart ||
                                        isProjectTerminatedOrCompleted },
                                    React.createElement(CommentsSummary, { id: 'p' + data.id, green: data.projectManagerGreenRatingCount, yellow: data.projectManagerYellowRatingCount, red: data.projectManagerRedRatingCount, notApplicable: data.projectManagerNotApplicableRatingCount, notRated: data.projectManagerNotRatingCount, notRatedCodes: data.projectManagerNotRatingCheckListItems, notCommented: data.projectManagerNotCommentedCount, notCommentedCodes: data.projectManagerNotCommentedCheckListItems, link: openModalLink, isVisible: !(projectState ===
                                            ProjectState.HasOnlyMasterCheckLists ||
                                            data.isMasterFunctionSummary) }),
                                    React.createElement(CommentsList, { comments: data.projectManagerComments })));
                            } }),
                        React.createElement(Column, { headerCellRender: function () { return (React.createElement("div", { title: "Project Manager Rating" }, "Rating")); }, width: 110, cssClass: styles.projectManagerRatingCell, cellRender: function (_a) {
                                var data = _a.data, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
                                return (React.createElement(AddActionItemWrapper, { projectId: projectId, gateId: gateId, gateProcessType: GateProcessTypeEnum.GateAssessment, disabled: !data.canPrincipalAddActionItem ||
                                        isProjectTerminatedOrCompleted, data: data, isForProjectManager: true, onActionItemSave: onRefreshActionItems },
                                    React.createElement(RatingCell, { rowIndex: rowIndex, columnIndex: columnIndex, onSave: function () { return _this._savePMSummary(data); }, onChange: function (value) {
                                            data.projectManagerOriginalRating = value;
                                            data.projectManagerRating = value;
                                            if (_this._gridRef.current) {
                                                _this._gridRef.current.repaintRows([rowIndex]);
                                            }
                                        }, rating: data.projectManagerRating, objectUniqueId: createUniqueId(ObjectType.ChecklistItem, data.id), disabled: !data.canPrincipalUpdateProjectManagerPart ||
                                            _this._loading ||
                                            isProjectTerminatedOrCompleted, section: ChecklistSections.ProjectManager, controlId: "pmRating".concat(data.id) })));
                            } }),
                        React.createElement(Column, { caption: "Gate Assessor Answer", width: 300, cssClass: styles.gateAssessorCell, cellRender: function (_a) {
                                var data = _a.data, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
                                return (React.createElement(EditCell, { rowIndex: rowIndex, columnIndex: columnIndex, value: data.assessorOriginalComment, onChange: function (value) {
                                        data.assessorOriginalComment = value;
                                        if (_this._gridRef.current) {
                                            _this._gridRef.current.repaintRows([rowIndex]);
                                        }
                                    }, onSave: function () { return _this._saveAssessorSummary(data); }, objectUniqueId: createUniqueId(ObjectType.ChecklistItem, data.id), withCopy: true, section: ChecklistSections.Assessor, disabled: !data.canPrincipalUpdateGateAssessorPart ||
                                        isProjectTerminatedOrCompleted },
                                    React.createElement(CommentsSummary, { id: 'a' + data.id, green: data.assessorGreenRatingCount, yellow: data.assessorYellowRatingCount, red: data.assessorRedRatingCount, notApplicable: data.assessorNotApplicableRatingCount, notRated: data.assessorNotRatingCount, notRatedCodes: data.assessorNotRatingCheckListItems, notCommented: data.assessorNotCommentedCount, notCommentedCodes: data.assessorNotCommentedCheckListItems, link: openModalLink, cssStyle: styles.commentsSummary, isVisible: !(projectState ===
                                            ProjectState.HasOnlyMasterCheckLists ||
                                            data.isMasterFunctionSummary) }),
                                    data.status && (React.createElement(FunctionSummaryStatus, { status: data.status, approved: data.approved, isVisible: !(projectState ===
                                            ProjectState.HasOnlyMasterCheckLists ||
                                            data.isMasterFunctionSummary) })),
                                    React.createElement(CommentsList, { comments: data.assessorComments })));
                            } }),
                        React.createElement(Column, { headerCellRender: function () { return React.createElement("div", { title: "Gate Assessor Rating" }, "Rating"); }, width: 110, cssClass: styles.gateAssessorRatingCell, cellRender: function (_a) {
                                var data = _a.data, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
                                return (React.createElement(AddActionItemWrapper, { projectId: projectId, gateId: gateId, gateProcessType: GateProcessTypeEnum.GateAssessment, disabled: !data.canPrincipalAddActionItem ||
                                        isProjectTerminatedOrCompleted, data: data, onActionItemSave: onRefreshActionItems },
                                    React.createElement(RatingCell, { rowIndex: rowIndex, columnIndex: columnIndex, onSave: function () { return _this._saveAssessorSummary(data); }, onChange: function (value) {
                                            data.assessorOriginalRating = value;
                                            data.assessorRating = value;
                                            if (_this._gridRef.current) {
                                                _this._gridRef.current.repaintRows([rowIndex]);
                                            }
                                        }, rating: data.assessorRating, objectUniqueId: createUniqueId(ObjectType.ChecklistItem, data.id), disabled: !data.canPrincipalUpdateGateAssessorPart ||
                                            _this._loading ||
                                            isProjectTerminatedOrCompleted, section: ChecklistSections.Assessor, controlId: "gRating".concat(data.id), confirmButton: data.canPrincipalUpdateGateAssessorPart ? (React.createElement("div", { className: styles.confirmButton },
                                            React.createElement(ConfirmButton, { id: 'tooltip' + data.id, onClick: function () {
                                                    return _this._saveOkAssessorPart(data.id, data, rowIndex);
                                                }, disabled: _this._loading ||
                                                    isProjectTerminatedOrCompleted }))) : (undefined) })));
                            } })));
                }));
            }),
            this._currentCheckListItem && (React.createElement(ChangeLogDialog, { onToggle: this._toggleLogModal, uniqueId: createUniqueId(ObjectType.ChecklistItem, this._currentCheckListItem.id) }))));
    };
    __decorate([
        observable
    ], AssessmentGateFunctionSummariesTable.prototype, "_functionSummaries", void 0);
    __decorate([
        observable
    ], AssessmentGateFunctionSummariesTable.prototype, "_currentCheckListItem", void 0);
    __decorate([
        observable
    ], AssessmentGateFunctionSummariesTable.prototype, "_loading", void 0);
    __decorate([
        observable.ref
    ], AssessmentGateFunctionSummariesTable.prototype, "_gridRef", void 0);
    __decorate([
        action.bound
    ], AssessmentGateFunctionSummariesTable.prototype, "_savePMSummary", null);
    __decorate([
        action.bound
    ], AssessmentGateFunctionSummariesTable.prototype, "reloadData", null);
    __decorate([
        action.bound
    ], AssessmentGateFunctionSummariesTable.prototype, "_saveAssessorSummary", null);
    __decorate([
        action.bound
    ], AssessmentGateFunctionSummariesTable.prototype, "_saveOkAssessorPart", null);
    __decorate([
        action.bound
    ], AssessmentGateFunctionSummariesTable.prototype, "_loadSummaries", null);
    __decorate([
        action.bound
    ], AssessmentGateFunctionSummariesTable.prototype, "_toggleLogModal", null);
    AssessmentGateFunctionSummariesTable = __decorate([
        observer
    ], AssessmentGateFunctionSummariesTable);
    return AssessmentGateFunctionSummariesTable;
}(React.PureComponent));
